import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from '@services/guard/auth.guard.service';
import { DeactivateGuardService } from '@services/guard/deactivate.guard.service';
import { ExworkersGuardService } from '@services/guard/exworkers.guard.service';
import { OnBoardingGuardService } from '@services/guard/on-boarding.guard.service';
import { PermissionsGuardService } from '@services/guard/permissions.guard.service';
import { PlatformGuardService } from '@services/guard/platform.guard.service';
import { PublicGuardService } from '@services/guard/public.guard.service';

import { PAGES } from '@/enums/pages.enum';
import { Permissions } from '@/enums/permissions/permissions.enum';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./presentation/pages/employee-base/employee-base.module').then((m) => m.EmployeePageModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./presentation/pages/auth/auth.module').then((m) => m.AuthPageModule)
  },
  {
    path: 'login',
    loadComponent: () => import('./presentation/pages/login/login.page').then((m) => m.LoginPageComponent)
  },
  {
    path: 'logout',
    loadChildren: () => import('./presentation/pages/logout/logout.module').then((m) => m.LogoutPageModule)
  },
  {
    path: 'codes',
    loadComponent: () =>
      import('./presentation/pages/mobile-install/mobile-install.page').then((m) => m.MobileInstallPageComponent),
    canLoad: [PlatformGuardService],
    data: { platforms: ['mobileweb', 'ios', 'android'] }
  },
  {
    path: 'mobileweb-landing',
    loadComponent: () =>
      import('./presentation/pages/mobileweb-landing/mobileweb-landing.page').then(
        (m) => m.MobilewebLandingPageComponent
      )
  },
  {
    path: 'home-exworkers',
    loadComponent: () =>
      import('./presentation/pages/home-exworkers/home-exworkers.page').then((m) => m.HomeExworkersPageComponent),
    canActivate: [AuthGuardService, PermissionsGuardService],
    data: {
      pagePermissions: [Permissions.INCOME_PAYSLIPS],
      redirectTo: PAGES.HOME
    }
  },
  {
    path: 'on-boarding',
    loadChildren: () =>
      import('./presentation/pages/on-boarding/on-boarding.module').then((m) => m.OnBoardingPageModule),
    canActivate: [PermissionsGuardService, ExworkersGuardService],
    data: {
      pagePermissions: [Permissions.ONBOARDING],
      redirectTo: PAGES.HOME
    }
  },
  {
    path: 'p/:id',
    redirectTo: 'viewer/:id',
    pathMatch: 'full'
  },
  {
    path: 'viewer/:id',
    loadComponent: () => import('./presentation/pages/viewer/viewer.page').then((m) => m.ViewerPageComponent),
    canActivate: [PublicGuardService]
  },
  {
    path: 'terms-and-conditions-inter',
    loadComponent: () =>
      import('./presentation/pages/terms-and-conditions-inter/terms-and-conditions-inter.page').then(
        (m) => m.TermsAndConditionsInterPageComponent
      )
  },
  {
    path: 'maintenance',
    loadComponent: () =>
      import('./presentation/pages/maintenance/maintenance.page').then((m) => m.MaintenancePageComponent),
    canDeactivate: [DeactivateGuardService]
  },
  {
    path: 'close-app',
    loadChildren: () => import('./presentation/pages/close-app/close-app.module').then((m) => m.CloseAppPageModule),
    canActivate: [OnBoardingGuardService, ExworkersGuardService]
  },
  {
    path: '**',
    redirectTo: 'not-found'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
